import { Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { DeviceOptionsViewModel, DeviceOptionViewModel_$reflection } from "../../RAWMap.Models/View/DeviceOptions.js";
import { float64_type, int32_type, option_type, array_type, string_type, record_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";

export class Devices extends Record {
    constructor(ipsilateralRight, ipsilateralLeft) {
        super();
        this.ipsilateralRight = ipsilateralRight;
        this.ipsilateralLeft = ipsilateralLeft;
    }
}

export function Devices_$reflection() {
    return record_type("Client.Visualization.StentPlanning.StentPlanningBindings.Devices", [], Devices, () => [["ipsilateralRight", DeviceOptionViewModel_$reflection()], ["ipsilateralLeft", DeviceOptionViewModel_$reflection()]]);
}

export function Devices_toViewModel(studyId, devices) {
    return new DeviceOptionsViewModel(studyId, devices.ipsilateralRight, devices.ipsilateralLeft);
}

export class ChildMeasurements extends Record {
    constructor(firstPlaneChildren, secondPlaneChildren, thirdPlaneChildren, midpointBounds, offsetMeasurementName) {
        super();
        this.firstPlaneChildren = firstPlaneChildren;
        this.secondPlaneChildren = secondPlaneChildren;
        this.thirdPlaneChildren = thirdPlaneChildren;
        this.midpointBounds = midpointBounds;
        this.offsetMeasurementName = offsetMeasurementName;
    }
}

export function ChildMeasurements_$reflection() {
    return record_type("Client.Visualization.StentPlanning.StentPlanningBindings.ChildMeasurements", [], ChildMeasurements, () => [["firstPlaneChildren", array_type(string_type)], ["secondPlaneChildren", array_type(string_type)], ["thirdPlaneChildren", array_type(string_type)], ["midpointBounds", array_type(string_type)], ["offsetMeasurementName", option_type(string_type)]]);
}

export class BaselineMeasurement extends Record {
    constructor(measurementName, measurementType, centerlineType, bottomCenterlineType, branch, bounds, transitionIndexes, distanceIndexes, measurements, childMeasurements) {
        super();
        this.measurementName = measurementName;
        this.measurementType = measurementType;
        this.centerlineType = centerlineType;
        this.bottomCenterlineType = bottomCenterlineType;
        this.branch = branch;
        this.bounds = bounds;
        this.transitionIndexes = transitionIndexes;
        this.distanceIndexes = distanceIndexes;
        this.measurements = measurements;
        this.childMeasurements = childMeasurements;
    }
}

export function BaselineMeasurement_$reflection() {
    return record_type("Client.Visualization.StentPlanning.StentPlanningBindings.BaselineMeasurement", [], BaselineMeasurement, () => [["measurementName", string_type], ["measurementType", string_type], ["centerlineType", string_type], ["bottomCenterlineType", string_type], ["branch", string_type], ["bounds", array_type(string_type)], ["transitionIndexes", array_type(int32_type)], ["distanceIndexes", array_type(int32_type)], ["measurements", array_type(float64_type)], ["childMeasurements", ChildMeasurements_$reflection()]]);
}

export class StentPlanScreenshots extends Record {
    constructor(Diameters, LengthsAndCArms) {
        super();
        this.Diameters = Diameters;
        this.LengthsAndCArms = LengthsAndCArms;
    }
}

export function StentPlanScreenshots_$reflection() {
    return record_type("Client.Visualization.StentPlanning.StentPlanningBindings.StentPlanScreenshots", [], StentPlanScreenshots, () => [["Diameters", string_type], ["LengthsAndCArms", string_type]]);
}

